import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Dashboard from './components/pages/Dashboard';
import UpdateStatusPage from './components/pages/UpdateStatusPage';
import HistoryPaid from './components/pages/HistoryPaid';
import Transaction from './components/pages/Transaction';
import Login from './components/LoginModal';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Analysis from './components/pages/Analysis';

const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <div className="min-h-screen bg-gray-100">
          <Navbar />
          <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
            <Routes>
              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              />
              <Route path="/login" element={<Login />} />
              <Route
                path="/update-status"
                element={
                  <PrivateRoute>
                    <UpdateStatusPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/history-paid"
                element={
                  <PrivateRoute>
                    <HistoryPaid />
                  </PrivateRoute>
                }
              />
              <Route path="/transactions" element={<Transaction />} />
              <Route
                path="/analysis"
                element={
                  <PrivateRoute>
                    <Analysis />
                  </PrivateRoute>
                }
              />
            </Routes>
          </main>
        </div>
      </AuthProvider>
    </Router>
  );
};

export default App;
